'use client';

import { Children, cloneElement, useState } from 'react';

import type { FC, ReactElement, SyntheticEvent } from 'react';

/**
 * Handles the Tabs State over the value and onChange api
 */
export const TabsController: FC<{
  children: ReactElement;
  defaultValue?: string | number;
  onChange?: (event: SyntheticEvent, newValue: string) => void;
}> = ({ children, defaultValue = null, onChange = () => void 0, ...props }) => {
  const [value, setValue] = useState( defaultValue );

  const handleChange = (event: SyntheticEvent, newValue: string): void => {
    onChange( event, newValue );
    setValue( newValue );
  };

  return (
    <>
      {Children.map( children, (child, index) =>
        cloneElement( child, {
          key: index,
          ...props,
          value,
          onChange: handleChange,
        } ) )}
    </>
  );
};
